/**
 * Created by Dimitri Sebeschuk on 10.07.15.
 */
/* globals SCS, debug, peakProtectObj */
(function ($) {
	'use strict';

	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	/**
	 *
	 * @constructor
	 */
	var SCSPeakProtection = function () {
		var mod = this;
		mod.init();
	};

	function triggerProtectionLifted() {
		var event;
		try {
			event = new Event('peak-protection-lifted');
		} catch(e) {
			// Fallback for IE
			event = document.createEvent('Event');
			event.initEvent('peak-protection-lifted', false, false);
		}
		document.documentElement.dispatchEvent(event);
		$('.modOCEAngularApp').removeAttr('data-protected');
	}

	SCSPeakProtection.prototype = {

		EXCEPTION_REDIRECT_PAGE: 'http://www.swisscom.ch',

		COOKIE_PREFIX: 'AcpAT-v3-',

		COOKIE_TARGET_URL: 'SCS-pp-tu41',

		MESSAGE_KEY: 'peakmsg',

		AJAX_IGNORE_URL_EXTENSIONS: ['js'],

		//Swisscom cookie
		//120 Seconds
		DEFAULT_COOKIE_TIMEOUT: 120,
		COOKIE_NAME: 'x-pkprtct',
		COOKIE_VALUE: 'scs',

		/**
		 * Call in constructor
		 */
		init: function () {
			$.ajaxSetup({
				//Case ECommerce AJAX call
				timeout: SCS.ajaxTimeout,
				global: true
			});
		},

		/**
		 * Call on document ready
		 */
		/* jslint maxstatements: 40 */
		on: function () {
			var mod = this;

			mod.ctx = $('body');

			mod.ajaxRequestQueue = [];

			mod.enabled = mod.ctx.data('peakprotect-enabled');
			mod.isMobile = SCS.utils.isMobilePage();

			//Peak Protect page 
			mod.peakprotectPage = mod.ctx.data('peakprotect-page');

			mod.ajaxUrls = mod.ctx.data('peakprotect-ajax-url-prefixes') || [];
			mod.showExceptionMessage = mod.ctx.data('peakprotect-show-exception-message');
			mod.exceptionMessage = mod.ctx.data('peakprotect-exception-message');
			mod.exceptionPageUrl = mod.ctx.data('peakprotect-exception-page-url');
			if (!mod.exceptionPageUrl || !mod.exceptionPageUrl.length) {
				mod.exceptionPageUrl = mod.EXCEPTION_REDIRECT_PAGE;
			}
			mod.ajaxRepeatMsg = mod.ctx.data('peakprotect-repeat-message');
			if (!mod.ajaxRepeatMsg || !mod.ajaxRepeatMsg.length) {
				mod.ajaxRepeatMsg = 'Please try your action again.';
			}

			//mod.jsDownloadUrl = '/mockpeakprotect/filter.js';
			mod.jsDownloadUrl = mod.ctx.data('peakprotect-js-download-url');
			if (!mod.jsDownloadUrl || !mod.jsDownloadUrl.length) {
				mod.enabled = false;
			}

			mod.isEditMode = $('body').hasClass('cq_isEditMode');

			if (mod.isEditMode || location.host === 'internal.swissptt.ch') {
				mod.enabled = false;
			}

			mod.ajaxPrefilterActive = false;
			mod.ctx.on('clipping', $.proxy(mod.reInitClipping, mod));

			mod.clippings = $('.scs-clipping-peakprotect');

			if(!mod.enabled) {
				//display clipping, break script
				mod.enableClipping();
				return;
			}
			
			if (mod.peakprotectPage) {
				//Peakprotect page, we need always to redirect
				mod.processProtectPage();
				return;
			}

			mod.showMessage();

			if(mod.clippings.length){
				mod.loadScript(mod.processCallback, $.proxy(mod.enableClipping, mod));
			} else {
				mod.loadScript(triggerProtectionLifted);
			}

			if (!mod.clippings.length && !mod.isProtectAjaxUrl(window.location.href)) {
				//clipping not found
				mod.ajaxPrefilterActive = true;
				$.ajaxPrefilter($.proxy(mod.onAjaxPrefilter, mod));
				return;
			}
		},

		//Fix for Lazy loading by tabs & ... components
		reInitClipping: function () {
			debug.log('SCS.PeakProtect > reInitClipping');
			var mod = this;
			mod.clippings = $('.scs-clipping-peakprotect');

			if (mod.clippings.length) {
				mod.ajaxPrefilterActive = false;
				if (!mod.enabled) {
					//display clipping, break script
					mod.enableClipping();
					return;
				}
				mod.loadScript(mod.processCallback, $.proxy(mod.enableClipping, mod));
			}
		},

		/**
		 * Use only by peakprotect.html, get target url from # and save in cookie
		 * if url is empty, get target url from cookie
		 * @returns {string}
		 */
		getTargetUrl: function () {
			var mod = this,
				url = window.location.hash.slice(1),
				temp;

			if (url && url.length) {
				temp = window.location.href.match(/^(?:[a-z]+:)?\/\/[^\/]+/) || ['https://www.swisscom.ch'];
				url = temp[0] + url;
				$.cookie(mod.COOKIE_TARGET_URL, url);
				return url;
			}
			url = $.cookie(mod.COOKIE_TARGET_URL);
			if (!url || !url.length) {
				//Exception url should set
				mod.exceptionHandler('Target url not found!');
				return;
			}
			return url;
		},

		getHashParameter: function (parameterName) {
			var hashParams = window.location.hash.slice(1),
				parameters = deparam(hashParams);
			if (parameters && parameters[parameterName]) {
				return decodeURIComponent(parameters[parameterName]);
			}
			return false;
		},

		removeHashParameter: function (parameterName) {
			var url = window.location.href,
				regexp = new RegExp('(?:(?!#|&)' + parameterName + '=.+?(&|$))', 'g');
			url = url.replace(regexp, '').replace(/(#|&)$/, '');
			window.history.replaceState({}, '', url);
		},
		
		processCallback: function (cb) {
			var mod = this;
			debug.log('SCS.PeakProtect > processClippingPageCallback');
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					peakProtectObj.protect(window.location.href, $.proxy(mod.exceptionHandler, mod), cb);
				} else {
					mod.exceptionHandler('peakProtectionObj is not exists!');
					return;
				}
			} catch (err) {
				mod.exceptionHandler(err);
				return;
			}
		},

		enableClipping: function () {
			debug.log('SCS.PeakProtect > enableClipping');
			var mod = this;
			//enable clipping

			triggerProtectionLifted();

			if (mod.clippings.length) {
				mod.clippings.addClass('scs-clipping');
				if (SCS.fn) {
					if (SCS.fn.clipping) {
						SCS.fn.clipping($('body'), $);
					}
					if (SCS.fn.clippingProductConfig) {
						SCS.fn.clippingProductConfig();
					}
					if (SCS.fn.clippingCart) {
						SCS.fn.clippingCart();
					}
				}
			}
		},

		/**
		 * Redirect to exception page
		 */
		exceptionHandler: function (exception, msg) {
			var mod = this;
			debug.log('SCS.PeakProtect > Exception: ' + exception);

			var imgUrl = '/dam/error/1.png?exception=' + encodeURIComponent('SCS.PeakProtect > Exception: ' + exception);
			$('<img />', {'src': imgUrl});
			if (!msg || !msg.length) {
				if (!mod.showExceptionMessage) {
					window.location.href = mod.exceptionPageUrl;
					return;
				}
				msg = mod.exceptionMessage;
			}
			window.location.href = mod.addMsgToUrl(mod.exceptionPageUrl, msg);
		},

		addMsgToUrl: function (url, msg) {
			var mod = this,
				ch = '#';
			if (url.indexOf('#') > -1) {
				ch = '&';
			}
			return url + ch + mod.MESSAGE_KEY + '=' + encodeURIComponent(msg);
		},

		showMessage: function () {
			var mod = this,
				msg = mod.getHashParameter(mod.MESSAGE_KEY);
			debug.log('SCS.PeakProtect > showMessage');

			if (msg && msg.length) {
				mod.removeHashParameter(mod.MESSAGE_KEY);
				if (mod.isMobile) {
					var p = $( '<p />' );
					p.text( msg );
					var $popupMessage = $('<div id="ajaxErrorPopup" data-role="popup"></div>').append(p);
					$popupMessage.appendTo('body');
					$popupMessage.popup().popup('open');
					$popupMessage.on('popupafterclose', function () {
						$popupMessage.popup('destroy');
						$popupMessage.remove();
					});
				} else {
					var div = $( '<div />' );
					div.text( msg );
					$(div).dialog();
				}
			}
		},

		loadScript: function (cb, cb1) {
			var mod = this;
			try {
				$.ajax({
					url: mod.jsDownloadUrl,
					dataType: 'script',
					cache: true
				}).done(function () {$.proxy(cb, mod).call(mod, cb1);})
					.fail(function (jqxhr, settings, exception) {
						debug.log('SCS.PeakProtect > Failed to download PeakProtect JS with ajax response: ' + jqxhr.responseText);
						mod.exceptionHandler(exception);
					});
			} catch (err) {
				mod.exceptionHandler(err);
				return;
			}
		},

		/**
		 * process protect page
		 */
		processProtectPage: function () {
			debug.log('SCS.PeakProtect > processProtectPage');
			var mod = this;
			mod.loadScript(mod.processProtectPageCallback);
		},

		processProtectPageCallback: function () {
			debug.log('SCS.PeakProtect > processProtectPageCallback');

			var mod = this;
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					debug.log('SCS.PeakProtect > processProtectPageCallback getOriginUrl=', mod.getTargetUrl());
					mod.setSwisscomCookie();
					peakProtectObj.protect(mod.getTargetUrl(),
						$.proxy(mod.exceptionHandler, mod), $.proxy(mod.processProtectPageRedirect, mod));
					return true;
				}
				mod.exceptionHandler('peakProtectionObj is not exists!');
			} catch (err) {
				mod.exceptionHandler(err);
			}
		},

		setSwisscomCookie: function(){
			var mod = this,
				options,
				expDate = new Date();
			if(!mod.cookieTimeout) {
				mod.cookieTimeout = (isNaN(parseInt(mod.ctx.data('peakprotect-cookie-timeout'), 10))) ? mod.DEFAULT_COOKIE_TIMEOUT : parseInt(mod.ctx.data('peakprotect-cookie-timeout'), 10);
			}

			debug.log('SCS.PeakProtect > setSwisscomCookie mod.cookieTimeout=', mod.cookieTimeout);

			expDate.setTime(expDate.getTime() + (mod.cookieTimeout * 1000));

			options = {
				path : '/',
				expires : expDate
			};
			$.cookie(mod.COOKIE_NAME, mod.COOKIE_VALUE, options);
		},

		/**
		 * Redirect to target url
		 */
		processProtectPageRedirect: function () {
			var mod = this;
			window.location.href = mod.getTargetUrl();
		},

		isCookie: function () {
			return document.cookie && document.cookie.indexOf(this.COOKIE_PREFIX) > -1;
		},

		isProtectAjaxUrl: function (url) {
			debug.log('SCS.PeakProtect > isProtectAjaxUrl url=' + url);
			var mod = this,
				extention;

			if (!mod.ajaxUrls || !mod.ajaxUrls.length) {
				return false;
			}

			if (!url || !url.length) {
				return false;
			}

			extention = url.split('.').pop().split(/\#|\?/)[0];
			if (mod.AJAX_IGNORE_URL_EXTENSIONS.indexOf(extention) > -1) {
				return false;
			}


			for (var i = 0, L = mod.ajaxUrls.length; i < L; i += 1) {
				if (url.indexOf(mod.ajaxUrls[i]) > -1) {
					debug.log('SCS.PeakProtect > isProtectAjaxUrl protected AJAX url=' + url);
					return true;
				}
			}
			return false;
		},

		/**
		 * Global event handler before AJAX send
		 */
		onAjaxPrefilter: function (options, originalOptions, jqXHR) {
			var mod = this;

			if (!mod.enabled || !mod.ajaxPrefilterActive) {
				return;
			}

			if (!originalOptions.pass) {

				if (!mod.isProtectAjaxUrl(options.url)) {
					return;
				}

				debug.log('SCS.PeakProtect > onAjaxPrefilter protected AJAX url=', options.url);

				//try to start ajax again
				originalOptions.pass = true; // pragma: allowlist-secret

				jqXHR.abort();
				debug.log('SCS.PeakProtect > abort AJAX Call for url: ' + options.url + ' call peak protection');

				mod.ajaxRequestQueue.push({opt: originalOptions, req: jqXHR});

				mod.loadScript(mod.ajaxPrefilterCallback);
			}
		},

		ajaxPrefilterCallback: function () {
			debug.log('SCS.PeakProtect > ajaxPrefilterCallback');
			var mod = this;
			try {
				if (peakProtectObj && peakProtectObj.protect) {
					mod.removeHashParameter(mod.MESSAGE_KEY);
					peakProtectObj.protect(mod.addMsgToUrl(window.location.href, mod.ajaxRepeatMsg),
						$.proxy(mod.exceptionHandler, mod), $.proxy(mod.callbackAjaxPeakProtect, mod));
					return true;
				}
				mod.exceptionHandler('peakProtectionObj is not exists!');
			} catch (err) {
				mod.exceptionHandler(err);
			}
		},

		callbackAjaxPeakProtect: function () {
			var mod = this,
				aj;

			mod.removeHashParameter(mod.MESSAGE_KEY);

			//Start AJAX calls
			//done, fail, always don't work, case may not initialize, please refactor ajax call to success, error & complete
			while (mod.ajaxRequestQueue.length) {
				aj = mod.ajaxRequestQueue.pop();
				$.ajax(aj.opt)
					.done(aj.req.done)
					.fail(aj.req.fail)
					.always(aj.req.always);
			}
		}
	};

	var obj = new SCSPeakProtection();
	$(document).ready($.proxy(obj.on, obj));

})(window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/libraries/SCS.PeakProtect.js
// module id = 86
// module chunks = 0